import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { API_BASE_URL } from "configs/AppConfig";
import { TRANSLATION_KEYS } from "constants/TranslationConstant";
import { DateFormater } from "functions/dateTimeFormat";
// import React from "react";
import { Stack } from "react-bootstrap";
import { useSelector } from "react-redux";

const NewsPdfViewer = ({ newsDetailsFetching }) => {
  const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <Stack gap={3} className="content">
      <label className="content-date">
        {newsDetailsFetching?.data === undefined ? (
          ""
        ) : (
          <DateFormater value={newsDetailsFetching?.data?.data?.publishDate} />
        )}
      </label>
      <label className="content-title">
        {newsDetailsFetching?.data === undefined ? (
          ""
        ) : (
          <LabelLang
            id="title"
            defaultValue={newsDetailsFetching?.data?.data?.title}
            translations={newsDetailsFetching?.data?.data[TRANSLATION_KEYS.NEWS]}
          />
        )}
      </label>
      <iframe
        className="content-iframe"
        src={`${API_BASE_URL}/${LabelLangString({
          id: "pdfUrl",
          currentLocale: currentLocale,
          defaultValue: newsDetailsFetching?.data?.data?.pdfUrl,
          translations: newsDetailsFetching?.data?.data[TRANSLATION_KEYS.NEWS],
      })}`}
      ></iframe>
    </Stack>
  );
};

export default NewsPdfViewer;
